import * as Yup from "yup";

export const audienceObject = {
  ID: "",
  brandID: "",

  percentage: {
    value: 0,
  },
  isEditable: true,
  audience_group: "",
  mandatoryTrueCount: "",
};

export function objectFromResponse(response, fields) {
  let data = {};
  data = {
    ...audienceObject,
  };

  let responseData = {};
  let additionalFields = [];
  for (let key of response.fields) {
    if (!key?.is_additional) {
      if (Array.isArray(Object.values(key)[0])) {
        data[Object.keys(key)[0]] = {
          value: Object.values(key)[0]?.length > 0 ? Object.values(key)[0] : [],
          mandatory: Object.values(key)[1] || false,
          userCount: Object.values(key)[3] || 0,
        };
      }

      if (typeof Object.values(key)[0] === "string") {
        data[Object.keys(key)[0]] = {
          value: !!Object.values(key)[0] ? Object.values(key)[0] : "",
          mandatory: Object.values(key)[1] || false,
          userCount: Object.values(key)[3] || 0,
        };
      }

      if (
        typeof Object.values(key)[0] === "object" &&
        !Array.isArray(Object.values(key)[0])
      ) {
        data[Object.keys(key)[0]] = {
          value: key[Object.keys(key)[0]],
          mandatory: Object.values(key)[1] || false,
          userCount: Object.values(key)[3] || 0,
        };
      }

      if (typeof Object.values(key)[0] === "number") {
        data[Object.keys(key)[0]] = {
          value: Object.values(key)[0] !== 0 ? Object.values(key)[0] : 0,
          mandatory: Object.values(key)[1] || false,
          userCount: Object.values(key)[3] || 0,
        };
      }
    }
  }

  for (let field of fields) {
    if (field.control_id === 2 && field.multi_select) {
      responseData = {
        ...responseData,
        [field.name]: {
          value: data[field.name]?.value ? data[field.name]?.value : [],
          mandatory: data[field.name]?.mandatory
            ? data[field.name]?.mandatory
            : false,
          userCount: data[field.name]?.userCount,
        },
      };
    }

    if (field.control_id === 1) {
      responseData = {
        ...responseData,
        [field.name]: {
          value: data[field.name]?.value ? data[field.name]?.value : {},
          mandatory: data[field.name]?.mandatory
            ? data[field.name]?.mandatory
            : false,
          userCount: data[field.name]?.userCount,
        },
      };
    }

    if (
      (field.control_id === 2 || field.control_id === 3) &&
      !field.multi_select
    ) {
      responseData = {
        ...responseData,
        [field.name]: {
          value: data[field.name]?.value ? data[field.name]?.value : "",
          mandatory: data[field.name]?.mandatory
            ? data[field.name]?.mandatory
            : false,
          userCount: data[field.name]?.userCount,
        },
      };
    }

    if (field.control_id === 4) {
      responseData = {
        ...responseData,
        [field.name]: {
          value: data[field.name]?.value ? data[field.name]?.value : null,
          mandatory: data[field.name]?.mandatory
            ? data[field.name]?.mandatory
            : false,
          userCount: data[field.name]?.userCount,
        },
      };
    }
  }
  return {
    ...responseData,
    percentage: data.percentage,
    ID: response.audience_id,
    brandID: response.brand_id,
    audience_group: data.audience_group,
    isEditable: response.is_editable,
  };
}

export function objectFormedForFormik() {
  return {
    ID: "",
    brandID: "",
    minimumAge: "",
    isEditable: true,

    audience_group: {
      value: "",
      mandatory: false,
    },

    age: {
      value: { min: "", max: "" },
      mandatory: false,
    },

    gender: {
      value: [],
      mandatory: false,
    },

    approx_mau: {
      value: "",
      mandatory: false,
    },

    arpu: {
      value: { min: "", max: "" },
      mandatory: false,
    },

    audience_location: {
      value: [],
      mandatory: false,
    },

    languages: {
      value: [],
      mandatory: false,
    },

    percentage: {
      value: 0,
    },
  };
}

export function objectFromFormData(formData, details) {
  let fields = [];

  for (let field in formData) {
    if (
      field !== "ID" &&
      field !== "brandID" &&
      field !== "isEditable" &&
      field !== "additionalFields" &&
      field !== "dirty" &&
      field !== "mandatoryTrueCount"
    ) {
      if (formData[field]?.value === null) {
        fields.push({
          [field]: {
            value: "",
            mandatory: false,
          },
        });
      } else {
        fields.push({ [field]: formData[field] });
      }
    }
  }

  return {
    brand_id: parseInt(details.activeBrand.ID),
    fields: fields,
  };
}

export const validationSchema = Yup.object().shape({
  audience_group: Yup.object().shape({
    value: Yup.string()
      .min(3, "Greater than 3 letters")
      .required("Audience Group is required"),
  }),

  age: Yup.object().shape({
    value: Yup.object().shape({
      min: Yup.number().lessThan(Yup.ref("max"), "Max age should be greater"),
      max: Yup.number()
        .nullable()
        .moreThan(Yup.ref("min"), "Max age should be greater"),
    }),
  }),

  gender: Yup.object().shape({
    value: Yup.array(),
  }),

  approx_mau: Yup.object().shape({
    value: Yup.string(),
  }),

  arpu: Yup.object().shape({
    value: Yup.object().shape({
      min: Yup.number().lessThan(Yup.ref("max"), "Max arpu should be greater"),
      max: Yup.number()
        .nullable()
        .moreThan(Yup.ref("min"), "Max arpu should be greater"),
    }),
  }),

  audience_location: Yup.object().shape({
    value: Yup.array(),
  }),

  languages: Yup.object().shape({
    value: Yup.array(),
  }),
});
